export type WasteSource =
  | 'Sieve'
  | 'Laser'
  | 'Cyclone'
  | 'X-ray'
  | 'Sweepings'
  | 'Other';

export type SieveSize =
  | '1.18mm'
  | '1.70mm'
  | '2.36mm'
  | '2.80mm'
  | '4.75mm'
  | '5mm'
  | '6.36mm'
  | 'closedPlates';

export interface WastePhoto {
  id?: number;
  dataUrl: string;
  fileName: string;
  size: number;
  mimeType: string;
  referenceId?: string;
  fileUrl?: string;
  description?: string;
  uploading?: boolean;
  uploadProgress?: number;
}

export interface WasteRegistrationData {
  // Source selection
  source: WasteSource;

  // Sieve specific - size selection (null for other sources)
  sieveSize: SieveSize | null;

  // Common fields for all sources
  otherKg: number;
  findings: string;

  // Photos - only for "other" source
  photos: WastePhoto[];
}

export interface WasteSourceOption {
  id: WasteSource;
  labelKey: string;
}

export interface SieveSizeOption {
  id: string;
  value: SieveSize;
  label: string;
}

export const WASTE_SOURCE_OPTIONS: WasteSourceOption[] = [
  { id: 'Sieve', labelKey: 'WASTE_REGISTRATION.OPTIONS.SIEVE' },
  { id: 'Laser', labelKey: 'WASTE_REGISTRATION.OPTIONS.LASER' },
  {
    id: 'Cyclone',
    labelKey: 'WASTE_REGISTRATION.OPTIONS.ASPIRATOR_CYCLONE',
  },
  { id: 'X-ray', labelKey: 'WASTE_REGISTRATION.OPTIONS.XRAY' },
  { id: 'Sweepings', labelKey: 'WASTE_REGISTRATION.OPTIONS.SWEEPINGS' },
  { id: 'Other', labelKey: 'WASTE_REGISTRATION.OPTIONS.OTHER' },
];

export const SIEVE_SIZE_OPTIONS: SieveSizeOption[] = [
  { id: 'size_1_18', value: '1.18mm', label: '1,18 mm' },
  { id: 'size_1_70', value: '1.70mm', label: '1,70 mm' },
  { id: 'size_2_36', value: '2.36mm', label: '2,36 mm' },
  { id: 'size_2_80', value: '2.80mm', label: '2,80 mm' },
  { id: 'size_4_75', value: '4.75mm', label: '4,75 mm' },
  { id: 'size_5', value: '5mm', label: '5 mm' },
  { id: 'size_6_36', value: '6.36mm', label: '6,36 mm' },
  { id: 'closedPlates', value: 'closedPlates', label: 'Closed Plates' },
];
